import createNamespaceContext from './helper/createNamespaceContext';
export var ELEMENTS_CONTEXT = 'fabricElementsCtx';
export var FabricElementsAnalyticsContext = createNamespaceContext(ELEMENTS_CONTEXT, 'FabricElementsAnalyticsContext');